// extracted by mini-css-extract-plugin
export default {"content":"ProofOfAddress_content__fv4jy"};